/**
 * @format
 * @flow strict-local
 */
// DEPENDENCIES

import {
	generatePath
} from "react-router-dom";

import routes from "../configs/routes";

// HELPERS

/**
 * getUrl - ...
 * 
 * @param {string} routeKey ...
 * @param {object} params ...
 */
const getUrl = (routeKey, params = {}) => {
	if(!routes[routeKey]) {
		return;
	}

	return generatePath(
		routes[routeKey].url, 
		params
	);
};

// EXPORT

export default {
	getUrl
};